import dayjs from 'dayjs'

export default {

  formatAsCurrency: function (value, digits = 0) {
    if (value === null || value === '' || isNaN(value)) {
      value = 0
    }
    return Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value)
  },
  formatAsPercent: function (value) {
    if (value === null || value === '' || isNaN(value)) {
      value = 0
    }

    return Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value)
  },
  formatAsDateTime: function (value) {
    if (value !== null && value !== undefined) {
      const st = new Date(value)
      return dayjs(st).format('MMM D, YYYY h:mm a')
    } else {
      return ''
    }
  },
  formatAsDate: function (value) {
    if (value !== null && value !== undefined) {
      const st = new Date(value)
      return dayjs(st).format('MMM D, YYYY')
    } else {
      return ''
    }
  },
  formatAsShortDate: function (value) {
    if (value !== null && value !== undefined) {
      const st = new Date(value)
      return dayjs(st).format('MMMM D')
    } else {
      return ''
    }
  },
  formatAsTime: function (value) {
    if (value !== null && value !== undefined) {
      const st = new Date(value)
      return dayjs(st).format('h:mm a')
    } else {
      return ''
    }
  },
  formatDateAndTimeAsIsoDateTime: function (dte, time) {
    if (dte !== null && dte !== undefined) {
      return dayjs(dte).format('YYYY-MM-DD') + 'T' +
        dayjs(time).format('HH:mm:ss')
    } else {
      return null
    }
  },
  dateDisplayFormat: function () {
    return ''
  }
}
